import React, { forwardRef, useImperativeHandle } from "react";
import { Form, Input } from "antd";
import SearchMapInput from "../inputs/SearchMapInput";

const formItemLayout = {
  labelCol: { span: 6, offset: 2 },
  wrapperCol: { span: 16 }
};

const AddPlacementForm = forwardRef(({ form, editingPersonInfo }, ref) => {
  const { getFieldDecorator } = form;
  useImperativeHandle(ref, () => ({
    form
  }));
  return (
    <Form
      layout={"horizontal"}
      className="add-person-form"
      id="add-person-form"
      hideRequiredMark={true}
    >
      <Form.Item
        label="Наименование:"
        {...formItemLayout}
        style={{ marginBottom: 10 }}
      >
        {getFieldDecorator("place", {
          rules: []
        })(
          <Input
            style={{ width: 368 }}
            placeholder={"Укажите наименование места размещения"}
          />
        )}
      </Form.Item>
      <Form.Item
        label="Адрес м. размещения:"
        {...formItemLayout}
        style={{ marginBottom: 10 }}
      >
        {getFieldDecorator("address")(
          <SearchMapInput
            style={{ width: 368 }}
            form={form}
            placeholder={"Укажите адрес места размещения"}
          />
        )}
      </Form.Item>
      <Form.Item
        label="Размещающая организация:"
        {...formItemLayout}
        style={{ marginBottom: 10 }}
      >
        {getFieldDecorator("organization", {
          rules: []
        })(
          <Input
            style={{ width: 368 }}
            placeholder={"Укажите наименование размещающей организации"}
          />
        )}
      </Form.Item>
    </Form>
  );
});

const WrappedAddPersonForm = Form.create({ name: "add_person_form" })(
  AddPlacementForm
);

export default WrappedAddPersonForm;
